export const state = () => ({
	isNewVersion: false,
	isArhiveVersion: false,
});

export const mutations = {
	initNewVersion (state) {
		state.isNewVersion = Boolean(String(this.$cookies.get('isNewVersion')) === 'true');
		state.isArhiveVersion = Boolean(String(this.$cookies.get('isArhiveVersion')) === 'true');
	},
	setNewVersion(state, value) {
		this.$cookies.set('isNewVersion', String(value));
		state.isNewVersion = value;
	},
	setArhiveVersion(state, value) {
		this.$cookies.set('isArhiveVersion', String(value));
		state.isArhiveVersion = value;
	},
};
